import i18n from './i18n';
import md5 from 'md5';
const { t } = i18n;

function getKeyCode(text = '', length = 10) {
  return `HB${md5(text)}`.substring(0, length);
}

// 用于跟踪缺失的翻译key
const missingKeys = new Set<string>();

export const $t = (key: string, args: any = {}, originalText = ''): string => {
    if (!key) {
      return '';
    }
    
    // 如果传入的是 {#text#} 格式，需要转换为hash key
    let processedKey = key;
    if (key.startsWith('{#') && key.endsWith('#}')) {
      const value = key.substring(2, key.length - 2).trim();
      processedKey = getKeyCode(value);
      originalText = originalText || value;
      // console.warn(`运行时转化: ${processedKey}`, originalText ? `Original: ${originalText}` : '');
    }
    
    // 尝试获取翻译
    const translation = t(processedKey, {...args}) as string;
    
    // 如果翻译不存在（返回的是key本身），记录并返回原文或key
    if (translation === processedKey) {
      if (!missingKeys.has(processedKey)) {
        missingKeys.add(processedKey);
        console.warn(`缺失翻译: ${processedKey}`, originalText ? `Original: ${originalText}` : '');
      }
      return originalText || key;
    }
    
    return translation;
}
